__turbopack_context__.v({
  "body": "Uscj-a_body",
  "column": "Uscj-a_column",
  "description": "Uscj-a_description",
  "infoBlock": "Uscj-a_infoBlock",
  "infoText": "Uscj-a_infoText",
  "inputsLabel": "Uscj-a_inputsLabel",
  "inputsWrapper": "Uscj-a_inputsWrapper",
  "link": "Uscj-a_link",
  "optImg": "Uscj-a_optImg",
  "optionContent": "Uscj-a_optionContent",
  "row": "Uscj-a_row",
  "secondaryLabel": "Uscj-a_secondaryLabel",
  "teamOption": "Uscj-a_teamOption",
});
